'use client';

import { signOut } from 'next-auth/react';
import { storeFutuUserInfo } from '@/shared/store/userInfo';
import { storeFutuWSUser } from '@/shared/store/wsUsers';
import { apiFe } from '@/shared/api';

export const signOutWithCleanup = async () => {
    localStorage.removeItem('stTK');

    try {
        // 0. 서버에서 세션 쿠키 만료 처리
        const res = await apiFe.post('/logout');
        console.log("signOutWithCleanup res", res)
        // 1. 웹소켓 연결 해제
        const { unConnect } = storeFutuWSUser.getState();
        unConnect();

        // 2. 사용자 정보 초기화 (자산 정보 포함)
        const { setFutuLogout } = storeFutuUserInfo.getState();
        setFutuLogout();

        // 3. NextAuth 로그아웃 (서버측 세션 정리 및 리디렉션)
        await signOut({ redirectTo: '/' });


    } catch (error) {
        console.error('로그아웃 중 오류 발생:', error);
        // 에러가 발생해도 로그아웃은 진행
        await signOut({ redirectTo: '/' });
    }
}; 